import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

export const UserIcon = ({ title = 'User Icon', ...props }) => (
    <SvgIcon {...props}>
        <title>{title}</title>
        <path d="M20.4093402 19c-.6845169-2.1991941-5.0578489-4.0968632-6.3061214-4.2949674-.4163301-.066273-.4296085-1.2163387-.4296085-1.2163387s1.2356581-1.2164816 1.5056931-2.8549017c.7205478 0 1.1676155-1.73773123.4462602-2.35012637.0290868-.6438252.929933-5.05586477-3.6255636-5.05586477-4.55544282 0-3.65474008 4.41203956-3.62646078 5.05586477-.7204043.61239514-.27421586 2.35177027.4454348 2.35177027.27010674 1.6367762 1.50659018 2.8532578 1.50659018 2.8532578s-.0124708 1.1500657-.42880092 1.2163387C8.64843694 14.9031368 4.27517666 16.8008773 3.5906598 19 1.97701737 17.0935576 1 14.6363117 1 11.9536768 1 5.91375937 5.9345397 1 12 1s11 4.91375937 11 10.9536768C23 14.6363117 22.0230544 17.0935576 20.4093402 19M12 0C5.3725185 0 0 5.37253218 0 11.9999912 0 18.6273797 5.3725185 24 12 24c6.6273934 0 12-5.3726203 12-12.0000088C24 5.37253218 18.6273934 0 12 0" fillRule="evenodd" />
    </SvgIcon>
);


export const ExpandArrowIcon = ({ title = 'Arrow Down Icon', ...props }) => (
    <SvgIcon {...props} viewBox="-5 -7 20 20">
        <title>{title}</title>
        <path d="M9 2.55116038L8.44250143 2 4.5 5.89767923.55749857 2 0 2.55116038 4.5 7" fillRule="evenodd" />
    </SvgIcon>
);


export const SettingsIcon = ({ disabled, title = "Settings Icon", ...props }) => (
    <SvgIcon {...props} color={disabled ? 'disabled' : "primary"} viewBox="0 0 18 18">
        <title>{title}</title>
        <path d="M15.7361628 9.94974874c0-.27135678.0918137-.54271356.0918137-.9045226 0-.36180905 0-.63316584-.0918137-.90452262l1.9280879-1.53768844c.1836274-.18090453.1836274-.36180905.0918137-.54271357l-1.8362742-3.16582914c-.0918137-.09045226-.2754411-.18090452-.5508822-.09045226l-2.2953427.9045226c-.4590685-.36180903-1.0099508-.63316582-1.560833-.9045226L11.1454775.4522613C11.2372912.18090453 10.9618501 0 10.7782227 0H7.10567438c-.1836274 0-.45906853.18090452-.45906853.36180904L6.27935102 2.8040201c-.55088224.18090452-1.00995077.54271357-1.560833.9045226l-2.20352898-.9045226c-.27544112-.09045226-.45906853 0-.64269594.18090452L.03601896 6.15075377c-.0918137.09045226 0 .36180904.18362742.54271357l1.92808784 1.44723618c0 .27135678-.0918137.54271357-.0918137.9045226 0 .36180906 0 .63316584.0918137.90452262L.21964638 11.4874372c-.18362742.1809045-.18362742.361809-.0918137.5427136l1.83627412 3.1658291c.0918137.0904523.27544112.1809045.55088224.0904523l2.29534267-.9045227c.45906855.3618091 1.0099508.6331659 1.56083303.9045227l.36725482 2.3517588c0 .1809045.18362742.361809.45906854.361809h3.6725483c.1836274 0 .4590685-.1809045.4590685-.361809l.3672548-2.3517588c.5508823-.2713568 1.1017645-.5427136 1.560833-.9045227l2.2953427.9045227c.1836274.0904522.4590685 0 .5508822-.1809046l1.8362742-3.1658291c.0918137-.1809045.0918137-.4522613-.0918137-.5427136l-2.1117153-1.44723616zM8.94194852 12.2110553c-1.74446043 0-3.21347974-1.4472362-3.21347974-3.16582917 0-1.71859296 1.4690193-3.16582915 3.21347974-3.16582915 1.74446038 0 3.21347978 1.4472362 3.21347978 3.16582915 0 1.71859297-1.4690194 3.16582917-3.21347978 3.16582917z" fillRule="evenodd" />
    </SvgIcon>
);

export const CloudOnIcon = ({ title = "Cloud On Icon", ...other }) => (
    <SvgIcon {...other} color="secondary" viewBox="0 0 20 20" width="20" height="20">
        <title>{title}</title>
        <path d="M16.1666667 8.25C15.5833333 5.275 13.0833333 3 10 3 7.58333333 3 5.5 4.4 4.5 6.5 1.91666667 6.85 0 9.0375 0 11.75 0 14.6375 2.25 17 5 17h10.8333333C18.1666667 17 20 15.075 20 12.625c0-2.275-1.75-4.2-3.8333333-4.375zm-2.9742263-2.11626732C12.3623282 5.28101128 11.2317366 4.75 10 4.75c-2.08333333 0-3.83333333 1.4875-4.41666667 3.5H5c-1.83333333 0-3.33333333 1.575-3.33333333 3.5s1.5 3.5 3.33333333 3.5h10.8333333c1.4166667 0 2.5-1.1375 2.5-2.625 0-1.0382497-.5277786-1.9059864-1.3283032-2.3354256l1.3324638-1.13668133s-.8326416-.77252198-2.1704102-.9093628c-.276184-1.8121338-1.6378173-3.2477417-1.6378173-3.2477417l-1.336826 1.1379441z" fillRule="evenodd" />
        <path d="M7.35172414 8.8245614L6 10.0526316 10.3448276 14 20 5.22807018 18.6482759 4l-8.3034483 7.5438596" />
    </SvgIcon>
);

export const LoadBalancerIcon = ({ title = "LoadBalancer Icon", ...other }) => (
    <SvgIcon {...other} viewBox="0 0 135 135" style={{ width: '45px', height: '45px' }}>
        <defs>

            <linearGradient id="a" x1="63.9997" y1="7.0336" x2="63.9997" y2="120.7894" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#4387fd" /><stop offset="1" stopColor="#4683ea" />
            </linearGradient>

            <clipPath id="b">
                <path d="M27.7911,115.2167L1.5406,69.75a11.499,11.499,0,0,1,0-11.499l26.25-45.4672a11.499,11.499,0,0,1,9.9585-5.75H90.25a11.499,11.499,0,0,1,9.9585,5.75l26.25,45.4672a11.499,11.499,0,0,1,0,11.499l-26.25,45.4672a11.499,11.499,0,0,1-9.9585,5.75H37.75A11.499,11.499,0,0,1,27.7911,115.2167Z" fill="none" /></clipPath></defs><title>Load-Balancing</title><path d="M27.7906,115.2166L1.54,69.7493a11.499,11.499,0,0,1,0-11.499L27.7906,12.7831a11.4991,11.4991,0,0,1,9.9585-5.75H90.25a11.4991,11.4991,0,0,1,9.9585,5.75L126.4594,58.25a11.499,11.499,0,0,1,0,11.499l-26.2506,45.4672a11.4991,11.4991,0,0,1-9.9585,5.75H37.7491A11.4991,11.4991,0,0,1,27.7906,115.2166Z" fill="url(#a)" />
        <g clipPath="url(#b)">
            <polygon points="121.417 84.25 79.635 42.469 54.417 50.333 48.583 53.667 57 62.083 45.5 62.75 45.75 73.58 39.365 81.677 78.896 121.208 98 122 121.417 84.25" opacity="0.07" /></g>
        <rect x="62" y="53" width="4" height="21.75" fill="#fff" />
        <path d="M44.9309,63H48a0,0,0,0,1,0,0V76a0,0,0,0,1,0,0H44a0,0,0,0,1,0,0V63.9309A0.9309,0.9309,0,0,1,44.9309,63Z" fill="#fff" />
        <path d="M80,63h3.0691A0.9309,0.9309,0,0,1,84,63.9309V76a0,0,0,0,1,0,0H80a0,0,0,0,1,0,0V63A0,0,0,0,1,80,63Z" fill="#fff" />
        <path d="M44.9938,61H83.0062A0.9938,0.9938,0,0,1,84,61.9938V65a0,0,0,0,1,0,0H44a0,0,0,0,1,0,0V61.9938A0.9938,0.9938,0,0,1,44.9938,61Z" fill="#fff" />
        <rect x="48" y="42" width="32" height="12" rx="0.9684" ry="0.9684" fill="#fff" /><rect x="39" y="72" width="13" height="10" rx="0.9759" ry="0.9759" fill="#fff" />
        <rect x="76" y="72" width="13" height="10" rx="0.9759" ry="0.9759" fill="#fff" /><rect x="57" y="72" width="14" height="10" rx="1.0127" ry="1.0127" fill="#fff" />
    </SvgIcon>
)

export const ConnectedIcon = ({color, ...other}) => (
    <SvgIcon viewBox="0 0 24 24">
        <path fill={color} d="M 20.292969 2.2929688 L 16.828125 5.7578125 L 15.949219 4.8789062 C 14.816219 3.7459062 12.841031 3.7449063 11.707031 4.8789062 L 10.5 6.0859375 L 9.7070312 5.2929688 L 8.2929688 6.7070312 L 17.292969 15.707031 L 18.707031 14.292969 L 17.914062 13.5 L 19.121094 12.292969 C 20.291094 11.122969 20.291094 9.2207812 19.121094 8.0507812 L 18.242188 7.171875 L 21.707031 3.7070312 L 20.292969 2.2929688 z M 6.7070312 8.2929688 L 5.2929688 9.7070312 L 6.0859375 10.5 L 4.8789062 11.707031 C 3.7089063 12.877031 3.7089063 14.779219 4.8789062 15.949219 L 5.7578125 16.828125 L 2.2929688 20.292969 L 3.7070312 21.707031 L 7.171875 18.242188 L 8.0507812 19.121094 C 8.6167812 19.687094 9.369875 20 10.171875 20 C 10.972875 20 11.726969 19.688094 12.292969 19.121094 L 13.5 17.914062 L 14.292969 18.707031 L 15.707031 17.292969 L 6.7070312 8.2929688 z"></path>
    </SvgIcon>
)

export const DisconnectedIcon = ({ color ,...other }) => (
    <SvgIcon viewBox="0 0 24 24">
    <path d="M 15.828125 2.0292969 C 15.0505 2.0291719 14.273531 2.3119062 13.707031 2.8789062 L 11.5 5.0859375 L 10.707031 4.2929688 L 9.2929688 5.7070312 L 11.085938 7.5 L 9.2929688 9.2929688 L 10.707031 10.707031 L 12.5 8.9140625 L 15.085938 11.5 L 13.292969 13.292969 L 14.707031 14.707031 L 16.5 12.914062 L 18.292969 14.707031 L 19.707031 13.292969 L 18.914062 12.5 L 21.121094 10.292969 C 22.291094 9.1229688 22.291094 7.2207812 21.121094 6.0507812 L 20.242188 5.171875 L 21.707031 3.7070312 L 20.292969 2.2929688 L 18.828125 3.7578125 L 17.949219 2.8789062 C 17.383219 2.3124062 16.60575 2.0294219 15.828125 2.0292969 z M 5.7070312 9.2929688 L 4.2929688 10.707031 L 5.0859375 11.5 L 2.8789062 13.707031 C 1.7089063 14.877031 1.7089063 16.779219 2.8789062 17.949219 L 3.7578125 18.828125 L 2.2929688 20.292969 L 3.7070312 21.707031 L 5.171875 20.242188 L 6.0507812 21.121094 C 6.6167812 21.687094 7.369875 22 8.171875 22 C 8.972875 22 9.7269688 21.688094 10.292969 21.121094 L 12.5 18.914062 L 13.292969 19.707031 L 14.707031 18.292969 L 5.7070312 9.2929688 z"></path>
</SvgIcon>
)

export const CloudOffIcon = ({ color, title = "Cloud Off Icon", ...other }) => (
    <SvgIcon {...other} color={color || "disabled"} viewBox="0 0 20 20" width="20" height="20">
        <title>{title}</title>
        <path d="M16.1666667 8C15.5833333 5.16666667 13.0833333 3 10 3c-1.25 0-2.41666667.33333333-3.33333333 1l1.25 1.25C8.5 4.83333333 9.25 4.66666667 10 4.66666667c2.5 0 4.5833333 2.08333333 4.5833333 4.58333333v.41666667h1.25c1.4166667 0 2.5 1.08333333 2.5 2.50000003 0 .9166666-.5 1.75-1.3333333 2.1666666l1.25 1.25c1.0833333-.75 1.75-2 1.75-3.4166666C20 10 18.25 8.16666667 16.1666667 8zM2.5 4.08333333l2.33333333 2.25C2.16666667 6.5 0 8.66666667 0 11.3333333c0 2.75 2.25 5 5 5h9.75L16.4166667 18 17.5 16.9166667 3.58333333 3 2.5 4.08333333zM6.41666667 8l6.66666663 6.6666667H5c-1.83333333 0-3.33333333-1.5-3.33333333-3.3333334C1.66666667 9.5 3.16666667 8 5 8h1.41666667z" fill="#BBB" fillRule="evenodd" />
    </SvgIcon>
);

export const StatusPendingIcon = ({ title = "Pending Icon", ...props }) => (
    <SvgIcon {...props} color="primary" viewBox="0 0 20 20" width="20" height="20">
        <title>{title}</title>
        <path d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H9v6l5.2 3.2.8-1.3-4.5-2.7V5z" fillRule="evenodd" />
    </SvgIcon>
);

export const SearchIcon = ({ color, title = "Search Icon", ...other }) => (
    <SvgIcon {...other} viewBox="0 0 18 18" width="100%" height="100%">
        <title>{title}</title>
        <path d="M11.4285714,10.0571429 L10.6971429,10.0571429 L10.4228571,9.78285714 C11.3371429,8.77714286 11.8857143,7.40571429 11.8857143,5.94285714 C11.8857143,2.65142857 9.23428571,0 5.94285714,0 C2.65142857,0 0,2.65142857 0,5.94285714 C0,9.23428571 2.65142857,11.8857143 5.94285714,11.8857143 C7.40571429,11.8857143 8.77714286,11.3371429 9.78285714,10.4228571 L10.0571429,10.6971429 L10.0571429,11.4285714 L14.6285714,16 L16,14.6285714 L11.4285714,10.0571429 L11.4285714,10.0571429 Z M5.94285714,10.0571429 C3.65714286,10.0571429 1.82857143,8.22857143 1.82857143,5.94285714 C1.82857143,3.65714286 3.65714286,1.82857143 5.94285714,1.82857143 C8.22857143,1.82857143 10.0571429,3.65714286 10.0571429,5.94285714 C10.0571429,8.22857143 8.22857143,10.0571429 5.94285714,10.0571429 L5.94285714,10.0571429 Z" fill={color || '#555555'}></path>
    </SvgIcon>
);

const closeIconStyleSheet = {
    closeIcon: {
        cursor: 'pointer',
    }
};
const CloseIconComponent = ({ classes, color, title = 'X Icon', ...other }) => (
    <SvgIcon className={classes.closeIcon} {...other} viewBox="0 0 20 20">
        <title>{title}</title>
        <path d="M18.76 0L10 8.76 1.24 0 0 1.24 8.76 10 0 18.76 1.24 20 10 11.24 18.76 20 20 18.76 11.24 10 20 1.24" fill={color || '#ffffff'} fillRule="evenodd" />
    </SvgIcon>
);
export const CloseIcon = withStyles(closeIconStyleSheet, { name: 'closeIconStyleSheet' })(CloseIconComponent);


export const AddIcon = ({ color, title = "Add Icon", ...props }) => (
    <SvgIcon viewBox="0 0 14 14" {...props} >
        <title>{title}</title>
        <path fill={color || '#FFF'} d="M14 8H8v6H6V8H0V6h6V0h2v6h6" />
        <path d="M-3-3h20v20H-3z" fill="none" fillRule="evenodd" />
    </SvgIcon>
);

export const SmallAddIcon = ({ color, title = "Add Icon", ...props }) => (
    <SvgIcon viewBox="0 0 20 20" {...props} >
        <title>{title}</title>
        <path fill={color || '#0088CE'} d="M16 11h-5v5H9v-5H4V9h5V4h2v5h5z" />
    </SvgIcon>
);

export const SubtractIcon = ({ color, title = "Minus Icons", ...props }) => (
    <SvgIcon viewBox="0 0 14 2" {...props}>
        <title>{title}</title>
        <path d="M0 2V0h14v2" fill={color || "#FFF"} fillRule="evenodd" />
    </SvgIcon>
);

export const CheckmarkIcon = ({ color, title = "Checkmark Icon", ...props }) => (
    <SvgIcon viewBox="0 0 18 14" {...props}>
        <title>{title}</title>
        <path fill={color || "#5F5F5F"} d="M5.6 10.6L1.4 6.4 0 7.8l5.6 5.6 12-12L16.2 0z" />
    </SvgIcon>
);

const criticalIconStyleSheet = {
    large: {
        width: 20,
    },
    small: {
        width: 16,
        height: 15
    },
};
const CriticalIconComponent = ({ classes, color, large, title = "Critical Icon", ...other }) => (
    <SvgIcon className={large ? classes.large : classes.small} viewBox="0 0 20 20" fill="none" fillRule="evenodd">
        <title>{title}</title>
        <path d="M10,0 C15.52992,0 20,4.46992 20,10 C20,15.52992 15.52992,20 10,20 C4.46992,20 0,15.52992 0,10 C0,4.46992 4.46992,0 10,0 Z M9,13 L11,13 L11,3 L9,3 L9,13 Z M9,17 L11,17 L11,15 L9,15 L9,17 Z" fill={color || "#DD1E31"} />
    </SvgIcon>
);
export const CriticalIcon = withStyles(criticalIconStyleSheet, { name: 'criticalIconStyleSheet' })(CriticalIconComponent);

const successIconStyleSheet = {
    large: {
        width: 24,
    },
    small: {
        width: 16,
        height: 15,
    },
};

const SuccessIconComponent = ({ classes, color, disabled, large, title = "Success Icon", ...other }) => (
    <SvgIcon className={large ? classes.large : classes.small} viewBox="0 0 16 16" fill="#5BA71B" fillRule="evenodd">
        <title>{title}</title>
        <path d="M6.260096,12.358912 L2.718336,8.817152 L3.842048,7.701504 L6.260096,10.11968 L12.402304,3.98336 L13.518976,5.099904 L6.260096,12.358912 Z M8,0 C3.575936,0 0,3.576064 0,8 C0,12.424064 3.575936,16 8,16 C12.423936,16 16,12.424064 16,8 C16,3.576064 12.423936,0 8,0 L8,0 Z" fill={color || "#5BA71B"} fillOpacity={disabled ? ".5" : "1"} />
    </SvgIcon>
);
export const SuccessIcon = withStyles(successIconStyleSheet, { name: 'successIconStyleSheet' })(SuccessIconComponent);


const warningIconStyleSheet = {
    large: {
        width: 20,
    },
    small: {
        width: 16,
        height: 15,
    },
};

const WarningIconComponent = ({ classes, large, title = "Warning Icon", ...props }) => {
    return (
        <SvgIcon className={large ? classes.large : classes.small} viewBox="0 0 16 16">
            <title>{title}</title>
            <path d="M8 .8L0 15.2h16L8 .8zm-.8 9.6h1.6V5.6H7.2v4.8zm0 3.2h1.6V12H7.2v1.6z" fill="#F18E00" fillRule="evenodd" />
        </SvgIcon>
    )
};
export const WarningIcon = withStyles(warningIconStyleSheet, { name: 'warningIconStyleSheet' })(WarningIconComponent);

const HelpIconComponent = ({ classes, color, title = "Help Icon", ...other }) => {
    return (
        <SvgIcon {...other} viewBox="0 0 20 20" width="100%" height="100%" className={classes.helpIcon}>
            <title>{title}</title>
            <path d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0z" className={classes.ring} />
            <path d="M10 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" className={classes.fill} />
            <path className={classes.mark} d="M11 16H9v-2h2zM13.1 9.67l-.9.81c-.8.63-1.2 1.17-1.2 2.52H9v-.45c0-.99.4-1.89 1.2-2.52l1.2-1.17c.4-.27.6-.72.6-1.26 0-.99-.9-1.8-2-1.8s-2 .81-2 1.8H6C6 5.62 7.8 4 10 4s4 1.62 4 3.6c0 .81-.4 1.53-.9 2.07z" />
        </SvgIcon>
    );
}
const helpIconStyleSheet = {
    helpIcon: {
        '&:hover $fill': {
            fill: '#0088CF'
        },
        '&:hover $mark': {
            fill: '#FFF'
        },
    },
    ring: {
        fill: '#0088CF'
    },
    fill: {
        fill: '#FFF'
    },
    mark: {
        fill: '#0088CF'
    }
};
export const HelpIcon = withStyles(helpIconStyleSheet, { name: 'helpIconStyleSheet' })(HelpIconComponent);

export const _InfoIcon = ({ classes, color, disabled = false, hoverEnabled = true, title = "Info Icon", ...props }) => (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" className={hoverEnabled ? classes.infoIcon : classes.infoIconWithoutHover}>
        <title>{title}</title>
        <path className={classes.hollow} d="M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0zm0 2c-4.4154305 0-8 3.5845695-8 8 0 4.4154305 3.5845695 8 8 8 4.4154305 0 8-3.5845695 8-8 0-4.4154305-3.5845695-8-8-8zM9 6V4h2v2H9zm0 10V8h2v8H9z" fill={color || '#888'} />
        <path className={classes.full} d="M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0zM8.75 6.25h2.5v-2.5h-2.5v2.5zm0 10h2.5v-7.5h-2.5v7.5z" fill={color || '#888'} fillRule="evenodd" fillOpacity={disabled ? ".5" : "1"} />
    </SvgIcon>
);

const InfoIconStyleSheet = {
    infoIcon: {
        width: '17px',
        height: '17px',
        '&:hover $full': {
            display: 'block'
        },
        '&:hover $hollow': {
            display: 'none'
        },
    },
    full: {
        display: 'none'
    },
    hollow: {},
    infoIconWithoutHover: {
        width: '17px',
        height: '17px',
        '& $full': {
            display: 'block'
        },
        '& $hollow': {
            display: 'none'
        },
    },
};
export const InfoIcon = withStyles(InfoIconStyleSheet, { name: 'InfoIconStyleSheet' })(_InfoIcon);


const stepStyleSheet = {
    size: {
        width: 24,
        height: 24,
    }
};

const _StepNumber = ({ classes, circleColor, numberColor, children, active = true, ...other }) => (
    <SvgIcon viewBox="0 0 24 24" className={classes.size}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <circle fill={circleColor || "#FFF"} cx="12" cy="12" r="12" fillOpacity={active ? 1 : .4} />
            <text fontFamily="Roboto-Medium, Roboto" fontSize="12" fontWeight="400" fill="#0088CF">
                <tspan fill={numberColor || "#0088CF"} x="9.09" y="17" fontWeight={'bold'}>
                    {children}
                </tspan>
            </text>
        </g>
    </SvgIcon>
);
export const StepNumber = withStyles(stepStyleSheet, { name: 'StepNumber' })(_StepNumber);


const _StepNumberInactive = ({ classes, circleColor, numberColor, children, ...other }) => (
    <SvgIcon className={classes.size} viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd" opacity=".4">
            <path d="M0 0h24v24H0z" />
            <circle stroke={circleColor || "#FFF"} cx="12" cy="12" r="11.5" />
            <text fontFamily="Roboto-Medium, Roboto" fontSize="12" fontWeight="400">
                <tspan fill={numberColor || "#fff"} x="9.09" y="17">{children}</tspan>
            </text>
        </g>
    </SvgIcon>
)

export const StepNumberInactive = withStyles(stepStyleSheet, { name: 'StepNumberInactive' })(_StepNumberInactive);

export const BackArrowIcon = ({ color, title = "Back Arrow Icon", ...other }) => (
    <SvgIcon {...other} viewBox="0 0 16 16">
        <title>{title}</title>
        <path fill={color || '#0088CF'} d="M3.8 7l5.6-5.6L8 0 0 8l8 8 1.4-1.4L3.8 9H16V7z" />
    </SvgIcon>
);


const paginationStyleSheet = {
    size: {
        width: 8,
        height: 13,
    }
};

const PaginationBackComponent = ({ classes, disabled = false, title = "Pagination Back", ...other }) => {
    return (
        <SvgIcon {...other} className={classes.size} viewBox="0 0 8 13" >
            <title>{title}</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.5">
                <g transform="translate(-1158.000000, -896.000000)" fill={disabled ? "#aaaaaa" : "#000000"}>
                    <polygon points="1165.4 907.1 1160.8 902.5 1165.4 897.9 1164 896.5 1158 902.5 1164 908.5"></polygon>
                </g>
            </g>
        </SvgIcon>
    );
};
export const PaginationBack = withStyles(paginationStyleSheet, { name: 'paginationStyleSheet' })(PaginationBackComponent);

const PaginationNextComponent = ({ classes, disabled = false, title = "Pagination Next", ...other }) => {
    return (
        <SvgIcon {...other} className={classes.size} viewBox="0 0 8 13" >
            <title>{title}</title>
            <g id="Application-Detail---Blacklist" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.5">
                <g id="[06a]-Blacklist" transform="translate(-1207.000000, -896.000000)" fill={disabled ? "#aaaaaa" : "#000000"}>
                    <polygon id="Shape" points="1207.6 907.3 1212.2 902.8 1207.6 898.2 1209 896.8 1215 902.8 1209 908.8"></polygon>
                </g>
            </g>
        </SvgIcon>
    );
};
export const PaginationNext = withStyles(paginationStyleSheet, { name: 'paginationStyleSheet' })(PaginationNextComponent);

export const CollapseIcon = ({ classes, title = "Collapse Icon", ...other }) => {
    return (
        <SvgIcon {...other} width="12px" height="13px" viewBox="0 0 12 13">
            <title>{title}</title>
            <g id="Boneyard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Group-12" transform="translate(-4.000000, -4.000000)">
                    <rect id="boundary" x="0" y="0" width="20" height="20"></rect>
                    <path d="M5.4,9 L10,13.6 L14.6,9 L16,10.4 L10,16.4 L4,10.4 L5.4,9 Z M5.4,4 L10,8.6 L14.6,4 L16,5.4 L10,11.4 L4,5.4 L5.4,4 Z" id="icn-collapse" fill="#0088CF" transform="translate(10.000000, 10.200000) scale(1, -1) translate(-10.000000, -10.200000) " />
                </g>
            </g>
        </SvgIcon>
    )
}

export const AllowlistIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" {...props}>
        <title>Allow List</title>
        <path d="M14 2.0005h-2c0-1.105-.895-2-2-2s-2 .895-2 2H6v3h8v-3z" fill="#0077C8" />
        <path d="M4 3v3h12V3h2c.5522847 0 1 .44771525 1 1v15c0 .5522847-.4477153 1-1 1H2c-.55228475 0-1-.4477153-1-1V4c0-.55228475.44771525-1 1-1h2zm5 12l-3-3-1 1 4 4 7-7-1-1-6 6z" fill="#5F5F5F" />
    </SvgIcon>
);

export const UploadIcon = ({ color, title = "Upload Icon", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <title>{title}</title>
            <path d="M7 15V9H3l7-7 7 7h-4v6H7zm-4 2h14v2H3v-2z" fill={color || "#0088CE"} fillRule="evenodd" />
        </SvgIcon>
    )
};

export const DownloadIcon = ({ color, title = "Download Icon", ...props }) => {
    return (
        <SvgIcon viewBox="0 -2 20 20" {...props}>
            <title>{title}</title>
            <path d="M14 6h-4V0H4v6H0l7 7 7-7zM0 15v2h14v-2H0z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
};

export const LockIcon = ({ title = "Lock Icon", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <title>{title}</title>
            <path d="M8.6 10.4c0-.88-.72-1.6-1.6-1.6-.88 0-1.6.72-1.6 1.6 0 .88.72 1.6 1.6 1.6.88 0 1.6-.72 1.6-1.6zM11 5.6V4c0-2.24-1.76-4-4-4S3 1.76 3 4v1.6h1.52V4c0-1.36 1.12-2.48 2.48-2.48 1.36 0 2.48 1.12 2.48 2.48v1.6H2.2c-.88 0-1.6.72-1.6 1.6v7.2c0 .88.72 1.6 1.6 1.6h9.6c.88 0 1.6-.72 1.6-1.6V7.2c0-.88-.72-1.6-1.6-1.6H11zm.8 8.8H2.2V7.2h9.6v8-.8z" fill="#757575" fillRule="evenodd" />
        </SvgIcon>
    )
};

export const PieChartIcon = ({ title = "Piechart Icon", ...props }) => (
    <SvgIcon viewBox="0 0 20 20" {...props}>
        <title>{title}</title>
        <path d="M18 11c0 4.971-4.029 9-9 9s-9-4.029-9-9 4.029-9 9-9v9h9z" fill="#5F5F5F" />
        <path d="M20 9h-9V0c4.971 0 9 4.029 9 9" fill="#0077C8" />
    </SvgIcon>
);

export const BasicIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" {...props}>
        <title>Basic Icon</title>
        <path d="M12.5 4.0005c0-.345.047-.677.121-1H0v2h12.621c-.074-.323-.121-.655-.121-1" fill="#5F5F5F" />
        <path d="M12.5 16.0005c0-.345.047-.677.121-1H0v2h12.621c-.074-.323-.121-.655-.121-1" fill="#5F5F5F" />
        <path d="M2.5 10.0005c0-.345.047-.677.121-1H0v2h2.621c-.074-.323-.121-.655-.121-1" fill="#5F5F5F" />
        <path d="M11.3789 9.0005c.074.323.121.655.121 1s-.047.677-.121 1h8.621v-2h-8.621z" fill="#5F5F5F" />
        <path d="M17 1.0005c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3" fill="#0077C8" />
        <path d="M7 7.0005c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3" fill="#0077C8" />
        <path d="M17 13.0005c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3" fill="#0077C8" />
    </SvgIcon>
);

export const BlockListIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" {...props}>
        <title>Blocklist Icon</title>
        <path d="M14 2.0005h-2c0-1.105-.895-2-2-2s-2 .895-2 2H6v3h8v-3z" fill="#0077C8" />
        <path d="M4 3v3h12V3h2c.5522847 0 1 .44771525 1 1v15c0 .5522847-.4477153 1-1 1H2c-.55228475 0-1-.4477153-1-1V4c0-.55228475.44771525-1 1-1h2zm11 6l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4z" fill="#5F5F5F" />
    </SvgIcon>
);

export const BruteForceIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" {...props}>
        <title>Bruteforce Icon</title>
        <path d="M12.2467754 14.7577702C11.6928627 14.7587023 8.31313113 14.4198693 8 14c-.31313113-.4198693-.54007604-2.7021399 0-4 .19192785-.23300084 1.31768472.3248794 1.50112465.5399161.15695314.2322899 0 1.4988412.49887535 2.4600839.5045776-.0848999.6651001-.1046753 1 0-.5722128-1.7295356-.1591492-3.45913696 0-4-.979126.43011475-3.21577388.25535326-4 0-1.02031573 2.1487859-.74896496 5.3827314 0 6 .74896496.6172686 2.36186538.5998647 3.1527867.7862719.3555141.1104566.1433559 2.0923461-1.21450162 2.0923461-1.3578575 0-4.27775934-.7176677-4.71740802-1.0289677C3.72989884 16.5015349 1.80386526 14.9041494 1 13H0c0-2 .00231934-7 0-9h1c1.95196533 0 5.6716919.93884277 7.00892.98673396C8.99768926 5.02214552 12.1233215 5.72665406 13 6c.8766785.27334595.5728149 8.7587023-.7532246 8.7577702z" id="Fill-1" fill="#5F5F5F" /><path id="Fill-4" fill="#0077C8" d="M16.0860758 12.6280741L20 7.9165997l-4.2027371-1.83241866L17.636876 0l-4.2120055 3.1135273-.8508921-2.67422904-1.5678419 3.82603504.7507344.0739397.7184447-1.00760063.5103559 1.5265563 1.6751751-.56467428-.6727011 2.27217616 2.802921 2.0907254-2.3466802 3.14771864 1.0550942 3.2565616-2.4940765.5763622-.0609915 1.9518244-1.2379269-.4936967L11 17.3303635 13.871245 20l.0349805-3.0099428 4.2132014.2406484-1.2616882-2.8556338z" />
    </SvgIcon>
);

export const WebScrapingIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" {...props}>
        <title>Webscraping Icon</title>
        <path d="M7 5h6c2.209139 0 4 1.790861 4 4v6H3V9c0-2.209139 1.790861-4 4-4zm10 4h2v4h-2V9zM1 9h2v4H1V9zm2 7h14c0 2.209139-1.790861 4-4 4H7c-2.209139 0-4-1.790861-4-4zm4-4c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2zm6 0c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2z" id="Combined-Shape" fill="#5F5F5F" /><path d="M11 3.7324356V5H9V3.7324356C8.40219863 3.3866262 8 2.74028237 8 2c0-1.1045695.8954305-2 2-2s2 .8954305 2 2c0 .74028236-.4021986 1.3866262-1 1.7324356z" id="Combined-Shape" fill="#0077C8" />
    </SvgIcon>
);

export const SlowClientIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" {...props}>
        <title>Slow Client Icon</title>
        <path d="M14.6220009 1.1348528C9.72566245-1.41828564 3.68797014.4816528 1.13483168 5.37799128c-2.5531077 4.89636923-.65316923 10.93406153 4.2432 13.48716923 4.89630772 2.5531385 10.93400002.6531692 13.48710772-4.2431692 2.5531384-4.8963385.6532-10.93400003-4.2431385-13.4871385m-1.156 2.21627693c3.6681231 1.91166154 5.0935692 6.45067693 3.1828616 10.11584617-1.9107077 3.6651692-6.4477231 5.0935692-10.1148616 3.1819077-3.6680923-1.9116923-5.09353845-6.4506769-3.18286152-10.11587694C5.2618163 2.86783743 9.79886245 1.43848358 13.4660009 3.35112973" id="icn-duration-20-copy" fill="#5F5F5F" /><path d="M15.8334462 9.77993846c0 3.19163074-2.5902154 5.77993844-5.7799385 5.77993844-2.17233847 0-4.06449232-1.1989538-5.0535077-2.9710154l4.42867692-2.80892304V4c3.74910768 0 6.40476928 2.58827692 6.40476928 5.77993846" id="Fill-4-Copy" fill="#0077C8" />
    </SvgIcon>
);

export const ClientEvaluationIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" {...props}>
        <title>Client Evaluation Icon</title>
        <path d="M2 0h16c1.1045695 0 2 .8954305 2 2v16c0 1.1045695-.8954305 2-2 2H2c-1.1045695 0-2-.8954305-2-2V2C0 .8954305.8954305 0 2 0zM1 4v12h18V4H1z" id="Combined-Shape" fill="#5F5F5F" /><path d="M3.52539088 14h1.2729492L3.7885745 8.18847656H2.51562524L3.52539088 14zm.0805664-7.2993164c0-.1969411-.06445248-.36523368-.19335937-.50488282-.1289069-.13964913-.30257052-.21305335-.5209961-.22021484-.20768332-.0071615-.38045177.0563958-.51831053.19067383-.13785877.134278-.2067871.29809473-.2067871.49145507 0 .2041026.067138.37239517.201416.50488282.13427802.13248764.30525612.20231116.51293945.20947265.2041026.0071615.37597587-.05460545.515625-.18530272.13964914-.13069727.20947266-.29272364.20947266-.486084z" id="i" fill="#0077C8" /><path d="M9.53955078 14c-.04296896-.1432299-.06087243-.3240549-.05371094-.5424805-.4798201.4475934-.9972303.6642254-1.5522461.6499024-.50488533-.0071615-.92293128-.1691879-1.25415038-.486084s-.4860841-.718829-.4645996-1.2058106c.02864597-.6123077.29361728-1.093911.79492186-1.4448242.5013046-.3509132 1.17447495-.5263672 2.01953126-.5263672l.82714843.0107422.07519532-.3974609c.0214845-.13964915.0214845-.27034446 0-.39208986-.07161494-.38672068-.3276345-.58544916-.7680664-.5961914-.27213678-.0071615-.51114806.06176685-.71704102.2067871-.20589295.14502026-.3321124.33927288-.3786621.58276368l-1.27294922.0107422c.02506522-.35807472.15217984-.67228056.38134765-.94262697.2291678-.2703464.53352675-.48071214.91308594-.6311035.3795592-.1503914.78059684-.22200526 1.203125-.21484376.63379223.01432298 1.12792793.2049949 1.48242183.57202147.354494.36702658.5013024.84236362.4404297 1.42602543l-.4458008 2.7231445-.0429687.4833984c-.0107422.2112641.016113.417154.0805664.6176758L10.8017578 14H9.53955078zm-1.31054687-.9345703c.26855604.0071615.51741423-.0546055.74658204-.1853027.2291678-.1306973.4243156-.2998851.58544922-.5075684l.19873046-1.1010742-.6069336-.0053711c-.4798201 0-.8629543.0904125-1.14941405.2712402-.28645977.1808277-.4493813.4287908-.48876953.7438965-.02864598.2399101.02416925.4287916.15844726.5666504.13427802.1378588.3195789.2103678.5559082.2175293z" id="a" fill="#0077C8" /><path d="M12.3876564 8.19921875c.0644534.7770221.5227822 1.3785786 1.375 1.80468745-.3186865.2041026-.5559074.4637029-.7116699.7788086-.1557625.3151058-.2193199.662433-.1906739 1.0419922.0465497.6875035.3276342 1.2434061.8432617 1.6677246.5156276.4243186 1.1547814.6293133 1.9174805.6149903.6946649-.014323 1.2469869-.2211081 1.6569824-.6203614.4099956-.3992533.5917158-.9229297.545166-1.5710449-.0644534-.8701215-.5854443-1.5289691-1.5629882-1.97656248.268556-.19336034.4672845-.43416197.5961914-.7224121.1289069-.28825014.1826173-.59708495.1611328-.92651368-.0501305-.67318045-.3151018-1.21476032-.7949219-1.62475586-.4798201-.40999554-1.0760055-.60782884-1.7885742-.59350586-.4261089.01074225-.8011865.10563062-1.1252441.28466797-.3240577.17903735-.5666496.42968588-.7277833.75195312-.1611336.32226724-.225586.6857076-.1933593 1.09033203zm1.7294922 3.56103515c-.0393883-.3616554.0304353-.6597482.2094726-.8942871.1790374-.2345389.4368473-.3553873.7734375-.3625488.3795592-.0071615.703612.1172676.972168.373291s.4243162.579181.4672851.9694824c.0393883.368817-.0322256.663329-.2148437.8835449-.1826181.220216-.440428.333903-.7734375.3410645-.3867207.0071615-.7116686-.1127918-.9748535-.3598633-.2631849-.2470715-.4162596-.5639629-.4592285-.9506836zm-.4511719-3.5180664c-.0322267-.32226724.0277499-.5890289.1799316-.80029297.1521818-.21126408.3768703-.32047522.6740723-.32763672.325848-.00716148.6042469.10384.8352051.33300782.2309582.22916782.3661293.52636537.4055175.89160157.0322268.3365902-.028645.60693256-.1826171.81103514-.1539722.2041026-.3759751.30973304-.6660157.31689454-.3294287.0071615-.6096179-.10563035-.8405761-.3383789-.2309582-.23274857-.3661294-.52815577-.4055176-.88623048z" id="8" fill="#0077C8" />
    </SvgIcon>
);

const menuIconStyleSheet = {
    icon: {
        cursor: 'pointer',
        height: '40px',
        width: '40px',
        float: 'right',
        '&:hover $menuCircle': {
            display: 'block'
        },
    },
    menuCircle: {
        display: 'none'
    }
};

export const _MenuIcon = ({ classes, ...other }) => (
    <SvgIcon viewBox="0 0 40 40" className={classes.icon} {...other}>
        <title>Menu Icon</title>
        <circle fill="#F3F3F3" cx="20" cy="20" r="20" className={classes.menuCircle} />
        <path d="M20 16c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </SvgIcon>
);
export const MenuIcon = withStyles(menuIconStyleSheet, { name: 'menuIconStyleSheet' })(_MenuIcon);

export const DeleteIcon = ({ color, title = "Delete Icon", ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <title>{title}</title>
        <path d="M4 17c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5H4v12zM17 2h-3.5l-1-1h-5l-1 1H3v2h14V2z" fill={color || "#5F5F5F"} />
    </SvgIcon>
);

export const EditIconComponent = ({ classes, color, small, title = 'Edit Icon', ...other }) => (
    <SvgIcon className={small ? classes.size : ''} {...other} viewBox="0 0 20 20">
        <title>{title}</title>
        <path d="M1 15.2V19h3.8l11-11.1L12 4.1 1 15.2zM18.7 5c.4-.4.4-1 0-1.4l-2.3-2.3c-.4-.4-1-.4-1.4 0l-1.8 1.8L17 6.9 18.7 5z" fill={color || "#5F5F5F"} />
    </SvgIcon>
);

const editIconStyleSheet = {
    size: {
        width: 12,
        height: 12,
    }
};

export const EditIcon = withStyles(editIconStyleSheet, { name: 'editIconStyleSheet' })(EditIconComponent);


export const ReloadIconComponent = ({ classes, color, ...other }) => (
    <SvgIcon id="icon-loop2" viewBox="0 0 32 32" className={classes.size}>
        <title>Reload Icon</title>
        <g fill={color || '#ffffff'}>
            <path d="M27.802 5.197c-2.925-3.194-7.13-5.197-11.803-5.197-8.837 0-16 7.163-16 16h3c0-7.18 5.82-13 13-13 3.844 0 7.298 1.669 9.678 4.322l-4.678 4.678h11v-11l-4.198 4.197z"></path>
            <path d="M29 16c0 7.18-5.82 13-13 13-3.844 0-7.298-1.669-9.678-4.322l4.678-4.678h-11v11l4.197-4.197c2.925 3.194 7.13 5.197 11.803 5.197 8.837 0 16-7.163 16-16h-3z"></path>
        </g>
    </SvgIcon>
);

const reloadIconStyleSheet = {
    size: {
        width: 15,
        height: 15,
    }
};

export const ReloadIcon = withStyles(reloadIconStyleSheet, { name: 'reloadIconStyleSheet' })(ReloadIconComponent);


const ArrowIconStyleSheet = {
    icon: {
        width: '40px',
        height: '40px',
        cursor: 'pointer',
        '&:hover $circle': {
            fill: '#ededed'
        },
    },
    iconDisabled: {
        cursor: 'default',
        fillOpacity: "0.3"
    },
    noHover: {
        '&:hover $circle': {
            fill: 'transparent'
        },
    },
    circle: {
        fill: 'transparent'
    },
};

export const _UpArrowIcon = ({ classes, color, disabled, noHover = false, ...other }) => {
    const iconClassname = classNames({
        [classes.icon]: true,
        [classes.iconDisabled]: disabled,
        [classes.noHover]: noHover,
    });
    const fill = disabled ? '#000000' : color || "#0077C8";
    return (
        <SvgIcon {...other} viewBox="0 0 40 40" className={iconClassname}>
            <title>Up Arrow Icon</title>
            <circle id="ripple" cx="20" cy="20" r="20" className={classes.circle} />
            <path fill={fill} d="M15.4 24.4l4.6-4.6 4.6 4.6L26 23l-6-6-6 6z" />
        </SvgIcon>
    );
}

export const UpArrowIcon = withStyles(ArrowIconStyleSheet, { name: 'ArrowIconStyleSheet' })(_UpArrowIcon);

export const _DownArrowIcon = ({ classes, color, disabled, noHover = false, ...other }) => {
    const iconClassname = classNames({
        [classes.icon]: true,
        [classes.iconDisabled]: disabled,
        [classes.noHover]: noHover,
    });
    const fill = disabled ? '#000000' : color || "#0077C8";
    return (
        <SvgIcon {...other} viewBox="0 0 40 40" className={iconClassname}>
            <title>Down Arrow Icon</title>
            <circle id="ripple" cx="20" cy="20" r="20" className={classes.circle} />
            <path fill={fill} d="M15.4 16.6l4.6 4.6 4.6-4.6L26 18l-6 6-6-6z" />
        </SvgIcon>
    );
}

export const DownArrowIcon = withStyles(ArrowIconStyleSheet, { name: 'ArrowIconStyleSheet' })(_DownArrowIcon);


export const RightArrowIcon = ({ color, title = "RightArrowIcon", ...props }) => (
    <SvgIcon viewBox="5 5 14 14" {...props} >
        <title>{title}</title>
        <g transform="matrix(-1 0 0 1 24 0)" fill="none" fillRule="evenodd">
            <path fill={color || '#FFF'} d="M15.4 16.5L10.8 12l4.6-4.6L14 6l-6 6 6 6z" />
        </g>
    </SvgIcon>
);

export const LeftArrowIcon = ({ color, title = "LeftArrowIcon", ...props }) => (
    <SvgIcon viewBox="5 5 14 14" {...props} >
        <title>{title}</title>
        <g fill="none" fillRule="evenodd">
            <path fill={color || '#FFF'} d="M15.4 16.5L10.8 12l4.6-4.6L14 6l-6 6 6 6z" />
        </g>
    </SvgIcon>
);

export const RightDoubleArrowIcon = ({ color, title = "RightArrowIcon", ...props }) => (
    <SvgIcon viewBox="5 5 14 14" {...props} >
        <title>{title}</title>
        <g fill="none" fillRule="evenodd">
            <path d="M12 16.5l4.6-4.5L12 7.4 13.4 6l6 6-6 6-1.4-1.5zm-7 0L9.6 12 5 7.4 6.4 6l6 6-6 6L5 16.5z" fill="#FFF" />
        </g>
    </SvgIcon>
);

export const LeftDoubleArrowIcon = ({ color, title = "LeftArrowIcon", ...props }) => (
    <SvgIcon viewBox="5 5 14 14" {...props} >
        <title>{title}</title>
        <g fill="none" fillRule="evenodd">
            <path d="M12.4 16.5L7.8 12l4.6-4.6L11 6l-6 6 6 6 1.4-1.5zm7 0L14.8 12l4.6-4.6L18 6l-6 6 6 6 1.4-1.5z" fill="#FFF" />
        </g>
    </SvgIcon>
);

export const VerifyIcon = ({ color, ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <title>Verify Icon</title>
        <path d="M6.5 4.5L11 0v3.1c3.9.5 7 3.8 7 7.9 0 4.1-3.1 7.4-7 7.9v-2c2.8-.5 5-2.9 5-5.9 0-3-2.2-5.4-5-5.9V9L6.5 4.5zM2.1 10c.2-1.4.7-2.7 1.6-3.9l1.4 1.4c-.5.8-.9 1.6-1 2.5h-2zM9 16.9v2c-1.4-.2-2.7-.7-3.9-1.6l1.4-1.4c.8.5 1.6.9 2.5 1zm-3.9-2.4l-1.4 1.4c-.9-1.2-1.5-2.5-1.6-3.9h2c.1.9.5 1.7 1 2.5z" fill="#0077C8" fillRule="evenodd" />
    </SvgIcon>
);

export const SensitivityVeryLowIcon = ({ color, ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <title>Very Low Sensitivity</title>
            <path d="M0 0h20v20H0z" />
            <path d="M18 12l-8 8-8-8 1.4-1.4L9 16.2V6h2v10.2l5.6-5.6L18 12zM9 4V0h2v4H9z" fill={color || "#5F5F5F"} />
        </g>
    </SvgIcon>
);

export const SensitivityLowIcon = ({ color, ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <title>Low Sensitivity Icon</title>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path d="M18 10l-1.4-1.4-5.6 5.6V2H9v12.2L3.4 8.6 2 10l8 8" fill={color || "#5F5F5F"} />
        </g>
    </SvgIcon>
);

export const SensitivityNormalIcon = ({ color, ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <title>Normal Sensitivity Icon</title>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path d="M7.17 9H0v2h7.17c.413 1.165 1.524 2 2.83 2s2.417-.835 2.83-2H20V9h-7.17c-.413-1.165-1.524-2-2.83-2s-2.417.835-2.83 2z" fill={color || "#5F5F5F"} />
        </g>
    </SvgIcon>
);

export const SensitivityHighIcon = ({ color, ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <title>High Sensitivity Icon</title>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path d="M18 10l-1.4 1.4L11 5.8V18H9V5.8l-5.6 5.6L2 10l8-8" fill={color || "#5F5F5F"} />
        </g>
    </SvgIcon>
);

export const SensitivityVeryHighIcon = ({ color, ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <title>Very High Sensitivity Icon</title>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path d="M18 8l-1.4 1.4L11 3.8V14H9V3.8L3.4 9.4 2 8l8-8 8 8zm-9 8h2v4H9v-4z" fill={color || "#5F5F5F"} />
        </g>
    </SvgIcon>
);

export const PeaceModeIcon = ({ color, ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <title>Peace Mode Icon</title>
        <path d="M10 17.928c1.725-.525 3.275-1.607 4.392-3.117C15.53 13.274 16 11.514 16 9.107v-3.87l-6-3c-.002 1.09-.002 6.322 0 15.692zM2 4l8-4 8 4v5.106c0 2.51-.458 4.81-2 6.894-1.542 2.085-3.708 3.447-6 4-2.292-.553-4.458-1.915-6-4-1.542-2.085-2-4.383-2-6.894V4z" fillRule="nonzero" fill="#FFF" />
    </SvgIcon>
);

export const PassiveModeIcon = ({ color, ...other }) => (
    <SvgIcon {...other} viewBox="0 0 20 20">
        <title>Passive Mode Icon</title>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path d="M15.978 13.275l-1.54-.12-.273-1.52c-.19-1.046-.69-1.927-1.49-2.65C11.904 8.32 11.044 8 10 8c-.78 0-1.486.213-2.128.643-.71.477-1.256 1.085-1.64 1.832l-.498.97-1.085.107c-.722.07-1.316.388-1.83.974C2.257 13.2 2 13.893 2 14.76c0 .904.3 1.64.93 2.304.616.644 1.272.936 2.07.936h10.82c.576 0 1.072-.22 1.522-.69.453-.475.658-1 .658-1.69 0-.64-.2-1.165-.615-1.645-.39-.432-.85-.657-1.407-.7zM20 5.605V6.75h-5l1.857-1.857C14.692 2.97 12.47 2 10.217 2c-2.89 0-5.78 1.586-8.464 4.658-.363.416-.995.458-1.41.095-.417-.363-.46-.995-.096-1.41C3.28 1.868 6.687 0 10.217 0c2.818 0 5.518 1.194 8.057 3.476L20 1.75v3.855zm-3.867 5.676c1.055.083 1.992.533 2.734 1.352.742.86 1.133 1.842 1.133 2.988 0 1.187-.39 2.21-1.21 3.07-.82.86-1.837 1.31-2.97 1.31H5c-1.367 0-2.54-.532-3.516-1.556C.508 17.42 0 16.194 0 14.76c0-1.35.43-2.497 1.29-3.52.858-.983 1.913-1.556 3.163-1.68C5 8.498 5.78 7.638 6.758 6.983 7.734 6.327 8.828 6 10 6c1.523 0 2.852.49 3.984 1.474 1.133 1.023 1.875 2.292 2.15 3.807z" fill="#5F5F5F" fillRule="nonzero" />
        </g>
    </SvgIcon>
);

export const LogsIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 20 20">
        <title>Logs Icon</title>
        <path d="M0 5h20v13.0081158C20 19.1082031 19.1017876 20 18.0092049 20H1.99079514C.89130934 20 0 19.1066027 0 18.0081158V5zm12 2v2h6V7h-6zM5 7v2h6V7H5zM2 7v2h2V7H2zm10 3v4h6v-4h-6zm-7 0v4h6v-4H5zm-3 0v4h2v-4H2zm10 5v3h6v-3h-6zm-7 0v3h6v-3H5zm-3 0v3h2v-3H2z" fill="#5F5F5F" />
        <path d="M0 1.0093689C0 .45190985.45530558 0 .99180311 0H19.0081969C19.5559546 0 20 .44335318 20 1.0093689V4H0V1.0093689z" fill="#0077C8" />
    </SvgIcon>
)

export const ServerIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 20 20">
        <title>Server Icon</title>
        <path fill="#5F5F5F" d="M4 17h5v1H4zM12 17h5v1h-5z" />
        <path d="M8 17.5c0-1.3807119 1.11928813-2.5 2.5-2.5 1.3807119 0 2.5 1.1192881 2.5 2.5S11.8807119 20 10.5 20C9.11928813 20 8 18.8807119 8 17.5zm4 0c0-.8284271-.6715729-1.5-1.5-1.5-.82842712 0-1.5.6715729-1.5 1.5s.67157288 1.5 1.5 1.5c.8284271 0 1.5-.6715729 1.5-1.5z" fill="#5F5F5F" /><path fill="#5F5F5F" d="M10 12h1v4h-1z" /><path d="M0 7h20v4.0020869C20 12.1055038 19.1017876 13 18.0092049 13H1.99079514C.89130934 13 0 12.1017394 0 11.0020869V7zm2 1v4h1V8H2zm2 0v4h1V8H4zm13 3c.5522847 0 1-.4477153 1-1 0-.55228475-.4477153-1-1-1s-1 .44771525-1 1c0 .5522847.4477153 1 1 1z" fill="#0088CE" /><path d="M0 6V1.99791312C0 .89826062.89130934 0 1.99079514 0H18.0092049C19.1017876 0 20 .89449617 20 1.99791312V6H0zm2-5v4h1V1H2zm2 0v4h1V1H4zm13 3c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1-1 .44771525-1 1 .4477153 1 1 1z" fill="#5F5F5F" />
    </SvgIcon>
)


const treeIconStyleSheet = {
    root: {},
    size: {
        width: 12,
        height: 12,
    }
};

let ExpandTreeIcon = ({ classes, ...props }) => (
    <SvgIcon viewBox="0 0 12 12" className={classes.size} {...props}>
        <title>Expand Tree Icon</title>
        <g fill="none" fillRule="evenodd">
            <rect stroke="#5F5F5F" x=".5" y=".5" width="11" height="11" rx="2" />
            <path fill="#5F5F5F" d="M3 5h6v2H3z" />
            <path fill="#5F5F5F" d="M5 3h2v6H5z" />
        </g>
    </SvgIcon>
)
ExpandTreeIcon = withStyles(treeIconStyleSheet, { name: 'ExpandTreeIcon' })(ExpandTreeIcon);
export { ExpandTreeIcon };


let CollapseTreeIcon = ({ classes, ...props }) => (
    <SvgIcon {...props} viewBox="0 0 12 12" className={classes.size}>
        <title>Collapse Tree Icon</title>
        <g fill="none" fillRule="evenodd">
            <rect stroke="#5F5F5F" x=".5" y=".5" width="11" height="11" rx="2" />
            <path fill="#5F5F5F" d="M3 5h6v2H3z" />
        </g>
    </SvgIcon>
)

CollapseTreeIcon = withStyles(treeIconStyleSheet, { name: 'CollapseTreeIcon' })(CollapseTreeIcon);
export { CollapseTreeIcon };

export const CalanderIcon = ({ classes, ...other }) => {
    return (
        <svg width="20" height="20">
            <title>Calander Icon</title>
            <path d="M15 11h-5v5h5v-5zM14 0v2H6V0H4v2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-1V0h-2zm3 18H3V7h14v11z" fill="#5F5F5F" fillRule="evenodd" />
        </svg>
    )
}




export const CompressionIcon = ({ classes, ...other }) => {
    return (
        <svg width="20" height="20">
            <title>Compression Icon</title>
            <path d="M2 3V0h14c.5522847 0 1 .44771525 1 1 .5522847 0 1 .44771525 1 1v1c0 .55228475-.4477153 1-1 1H4v6h13c.5522847 0 1 .4477153 1 1v1c0 .5522847-.4477153 1-1 1 0 .5522847-.4477153 1-1 1H2V3zm8 15h1.0853529c.2059182-.5825962.7615377-1 1.4146471-1 .8284271 0 1.5.6715729 1.5 1.5s-.6715729 1.5-1.5 1.5c-.6531094 0-1.2087289-.4174038-1.4146471-1H4.91464715C4.70872894 19.5825962 4.15310941 20 3.5 20c-.82842712 0-1.5-.6715729-1.5-1.5S2.67157288 17 3.5 17c.65310941 0 1.20872894.4174038 1.41464715 1H6v-3h4v3z" fill="#5F5F5F" />
            <rect fill="#0088CE" x="6" y="5" width="12" height="4" rx="1" />
        </svg>
    )
}

export const CachingIcon = ({ classes, ...other }) => {
    return (
        <svg width="20" height="20">
            <title>Caching Icon</title>
            <circle stroke="#5F5F5F" strokeWidth="2" cx="10" cy="10" r="9" fill="#ffffff" />
            <path fill="#0088CE" d="M9.42857143 4H14l-3.4285714 5H14l-5.71428571 7 1.14285714-5H6z" />
        </svg>
    )
}

export const ClickjackingIcon = () => {
    return (
        <svg width="20" height="20">
            <title>Clickjacking Icon</title>
            <path d="M17.9927 10.7498l-7.037-1.53c-.204-.044-.416-.044-.62 0-.787.172-1.287.948-1.116 1.736l1.53 7.036c.059.274.196.525.394.723.57.569 1.494.569 2.064 0l1.205-1.206 2.064 2.063c.57.571 1.494.571 2.064 0l1.032-1.031c.57-.57.57-1.494 0-2.064l-2.064-2.064 1.206-1.205c.197-.198.335-.449.394-.723.171-.787-.329-1.564-1.116-1.735" fill="#1188C9" />
            <path d="M8.7559-.0002c4.836 0 8.756 3.92 8.756 8.756 0 .133-.014.261-.02.391l-2.901-.63-.067-.519c-.38-2.896-2.86-5.079-5.768-5.079-3.218 0-5.837 2.619-5.837 5.837 0 2.909 2.183 5.389 5.079 5.768l.519.068.631 2.9c-.131.006-.26.02-.392.02-4.836 0-8.756-3.92-8.756-8.756s3.92-8.756 8.756-8.756zm0 4.3779c2.223 0 4.039 1.663 4.321 3.81l-1.812-.395c-.203-.043-.411-.065-.619-.065-.207 0-.415.022-.62.066-1.572.342-2.574 1.899-2.232 3.472l.394 1.811c-2.147-.281-3.81-2.097-3.81-4.321 0-2.418 1.96-4.378 4.378-4.378z" fill="#5F5F5F" />
        </svg>
    )
}

export const TrustedHostIcon = () => {
    return (
        <svg width="20" height="20">
            <title>Trusted Host Icon</title>
            <path fillRule="evenodd" d="M2 16h16V2H2v14zM18 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h3v2h10v-2h3c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z" fill="#5F5F5F" />
            <path fill="#0088CE" d="M3 10.6578947L7.34482759 15 17 5.35087719 15.6482759 4l-8.30344831 8.2982456-2.99310345-2.99122806z" />
        </svg>
    )
}


export const OverviewIcon = () => {
    return (
        <svg width="20" height="20">
            <title>Overview Icon</title>
            <path d="M11.1406 13.398c-.417.699-1.322.928-2.021.511-.7-.418-.928-1.323-.511-2.022.417-.699 8.81-11.887 8.81-11.887s-5.861 12.699-6.278 13.398" fill="#0077C8" />
            <path d="M2 10.8277c0 2.53 1.159 4.858 3.181 6.386.44.333.527.96.194 1.401-.333.44-.96.526-1.4.194C1.449 16.8997 0 13.9907 0 10.8277c0-5.514 4.486-10 10-10 1.326 0 2.589.265 3.749.735-.404.539-.822 1.098-1.249 1.671-.788-.26-1.626-.406-2.5-.406-4.411 0-8 3.589-8 8zm14.6587-4.4253c.323-.695.643-1.384.95-2.048 1.488 1.747 2.391 4.005 2.391 6.473 0 3.163-1.448 6.072-3.974 7.982-.18.136-.392.202-.602.202-.303 0-.602-.137-.799-.397-.333-.441-.245-1.067.195-1.401 2.021-1.528 3.18-3.855 3.18-6.386 0-1.635-.495-3.157-1.341-4.425z" fill="#5F5F5F" />
        </svg>
    )
}


export const ErrorIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 26 26" {...props} >
            <title>Error Icon</title>
            <path d="M13 0c7.1882526 0 13 5.81168312 13 13 0 7.1881887-5.8118113 13-13 13-7.18831688 0-13-5.8117474-13-13C0 5.81161925 5.81161925 0 13 0z" fill="#FFF" fillRule="nonzero" />
            <path d="M13 1C6.363904 1 1 6.363904 1 13c0 6.635904 5.363904 12 12 12 6.635904 0 12-5.364096 12-12 0-6.636096-5.364096-12-12-12z" fill="#DD1E31" />
            <path d="M11.8 16.6v-12h2.4v12h-2.4zm0 4.8V19h2.4v2.4h-2.4z" fill="#FFF" />
        </SvgIcon>
    )
}


export const EmailIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 16 14" {...props} >
            <title>Email Icon</title>
            <path d="M14.4.6H1.6C.72.6 0 1.32 0 2.2v9.6c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6V2.2c0-.88-.72-1.6-1.6-1.6zm0 3.2L8 7.8l-6.4-4V2.2l6.4 4 6.4-4v1.6z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
}



export const CompanyIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props} >
            <title>Company Icon</title>
            <path d="M12 4V2.60391006C12 2.04019699 11.5536144 1.6 11.0029699 1.6H4.99703014C4.45303631 1.6 4 2.04946585 4 2.60391006V4h8zm.8 0h2.1991283C15.5518945 4 16 4.45576096 16 5.00247329v9.99505341C16 15.5511774 15.5553691 16 14.9991283 16H1.00087166C.4481055 16 0 15.544239 0 14.9975267V5.00247329C0 4.44882258.44463086 4 1.00087166 4H3.2V1.0093689C3.2.45190985 3.65015178 0 4.19121056 0h7.61757884C12.3562199 0 12.8.44335318 12.8 1.0093689V4z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
}

export const PhoneIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props} >
            <title>Phone Icon</title>
            <path d="M11.9111111 10.5777778c-.2666667-.0888889-.6222222 0-.8888889.1777778l-1.95555553 1.9555555C6.57777778 11.4666667 4.53333333 9.33333333 3.2 6.84444444l1.95555556-1.95555555C5.42222222 4.62222222 5.51111111 4.26666667 5.33333333 4c-.26666666-.97777778-.44444444-2.04444444-.44444444-3.11111111C4.88888889.35555556 4.53333333 0 4 0H.88888889C.35555556 0 0 .35555556 0 .88888889 0 9.24444444 6.75555556 16 15.1111111 16 15.6444444 16 16 15.6444444 16 15.1111111V12c0-.5333333-.3555556-.8888889-.8888889-.8888889-1.0666667 0-2.1333333-.1777778-3.2-.5333333z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
}

export const LocationIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props} >
            <title>Location Icon</title>
            <path d="M6 0C2.88 0 .4 2.48.4 5.6.4 9.76 6 16 6 16s5.6-6.24 5.6-10.4C11.6 2.48 9.12 0 6 0zm0 7.6c-1.12 0-2-.88-2-2s.88-2 2-2 2 .88 2 2-.88 2-2 2z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
}

export const DarkLockIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props} >
            <title>Lock Icon</title>
            <path d="M11 5.6V4c0-2.24-1.76-4-4-4S3 1.76 3 4v1.6h-.8c-.88 0-1.6.72-1.6 1.6v7.2c0 .88.72 1.6 1.6 1.6h9.6c.88 0 1.6-.72 1.6-1.6V7.2c0-.88-.72-1.6-1.6-1.6H11zM7 12c-.88 0-1.6-.72-1.6-1.6 0-.88.72-1.6 1.6-1.6.88 0 1.6.72 1.6 1.6 0 .88-.72 1.6-1.6 1.6zm2.48-6.4H4.52V4c0-1.36 1.12-2.48 2.48-2.48 1.36 0 2.48 1.12 2.48 2.48v1.6z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
}

export const LinkingIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 16 10" {...props} >
            <title>Link Icon</title>
            <g fill="#5F5F5F" fillRule="evenodd">
                <path d="M5 5.83333333h6V4.16666667H5z" />
                <path d="M5 1.58333333h2V0H5C2.25 0 0 2.25 0 5s2.25 5 5 5h2V8.41666667H5c-1.91666667 0-3.41666667-1.5-3.41666667-3.41666667 0-1.91666667 1.5-3.41666667 3.41666667-3.41666667zM11 1.58333333H9V0h2c2.75 0 5 2.25 5 5s-2.25 5-5 5H9V8.41666667h2c1.9166667 0 3.4166667-1.5 3.4166667-3.41666667 0-1.91666667-1.5-3.41666667-3.4166667-3.41666667z" />
            </g>
        </SvgIcon>
    )
}

export const SerialIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 16 14" {...props} >
            <title>Serial Icon</title>
            <path d="M14.2222222 0C15.2 0 16 .7875 16 1.75v10.5c0 .9625-.8 1.75-1.7777778 1.75H1.77777778C.8 14 0 13.2125 0 12.25V1.75C0 .7875.8 0 1.77777778 0H14.2222222zM2 4v6h1V4H2zm10 0v6h2V4h-2zM7 4v6h2V4H7zM4 4v6h1V4H4zm6 0v6h1V4h-1z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
}

export const IPAllocationIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <title>IP Allocation Icon</title>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M12 6v3H9v2H7V5h5v1zm-2 0H9v2h1V6zm5.893 3.066a6.048 6.048 0 0 0-1.994.035A6 6 0 1 0 9.1 13.9c-.065.356-.1.724-.1 1.1 0 1.152.325 2.228.887 3.142A65.874 65.874 0 0 1 8 20c-5.333-5.054-8-9.054-8-12a8 8 0 1 1 16 0c0 .341-.036.696-.107 1.066zM4 5h2v6H4V5z"
                    fill="#5F5F5F" />
                <path
                    d="M18.742 15.528c0-.151.051-.302.051-.503 0-.2 0-.352-.05-.502l1.07-.855c.102-.1.102-.2.051-.301l-1.02-1.759c-.05-.05-.153-.1-.306-.05l-1.275.502c-.255-.2-.561-.351-.867-.502l-.204-1.307c.05-.15-.102-.251-.204-.251h-2.04c-.102 0-.255.1-.255.201l-.204 1.357c-.307.1-.562.301-.868.502l-1.224-.502c-.153-.05-.255 0-.357.1l-1.02 1.76c-.051.05 0 .2.102.3l1.071.805c0 .15-.05.301-.05.502s0 .352.05.503l-1.071.854c-.102.1-.102.2-.051.301l1.02 1.76c.051.05.153.1.306.05l1.275-.503c.255.201.561.352.868.502l.204 1.307c0 .1.102.201.255.201h2.04c.102 0 .255-.1.255-.201l.204-1.307c.306-.15.612-.301.867-.502l1.275.502c.102.05.255 0 .306-.1l1.02-1.759c.052-.1.052-.251-.05-.301l-1.174-.804zM15 16.667A1.687 1.687 0 0 1 13.333 15c0-.905.762-1.667 1.667-1.667s1.667.762 1.667 1.667-.762 1.667-1.667 1.667z"
                    fill="#0088CE" />
            </g>
        </SvgIcon>

    )
}


export const FirewallLogsIcon = ({ props }) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <title>Firewall Logs Icon</title>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M2 9h2V7H2v2zm0 5h2v-4H2v4zm0 4h2v-3H2v3zm3 0v-3h3.015c-.007-.151-.017-.302-.014-.456.003-.187.032-.363.049-.544H5v-4h4.724c.256-.337.54-.669.844-1H5V7h6v1.551a28.32 28.32 0 0 1 1-.971V7h.579c.971-.891.318-1.998.318-2H0v13.008C0 19.107.892 20 1.991 20h8.328a7.525 7.525 0 0 1-1.5-2H5zM20 4V1.01A.995.995 0 0 0 19.008 0H.992C.455 0 0 .451 0 1.01V4h20z"
                    fill="#5F6060" />
                <path
                    d="M16.418 19.723c2.323-.879 3.563-2.789 3.563-5.143 0 0 .169-2.156-1.644-3.895.05.698-.49 1.396-1.114 1.273-1.324-.256-.491-2.376-.491-2.376S17.565 6.764 13.914 5c0 0 1.083 1.637-1.421 3.92-2.23 2.034-3.456 3.627-3.492 5.66-.05 2.732 1.985 4.998 4.606 5.42 0 0-4.348-2.504.283-8.482 0 0-.515 5.587 1.667 5.66 1.004.033.39-1.838.39-1.838s3.367 1.096.47 4.383"
                    fill="#0088CE" />
            </g>
        </SvgIcon>
    )
}





export const FilterIcon = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <title>Filter Icon</title>
            <path d="M8 16h4v-2H8v2zM1 4v2h18V4H1zm3 7h12V9H4v2z" fill={color || "#5F5F5F"} fillRule="evenodd" />
        </SvgIcon>
    )
}


export const ExternalLinkIcon = ({ color, className, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 22 22" {...props}>
            <title>External Link Icon</title>
            <path d="M20 20H4V4h9V2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-9h-2v9zM15 4h3.6l-9.8 9.8 1.4 1.4L20 5.4V9h2V2h-7v2z" fill={color || "#0088CE"} fillRule="evenodd" />
        </SvgIcon>
    )
}

export const ResourcesIcon = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <title>Resources Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M.5 8.5h8v-8H1C.72385762.5.5.72385762.5 1v7.5zM.5 11.5V19c0 .2761424.22385762.5.5.5h7.5v-8h-8zM11.5.5v8h8V1c0-.27614238-.2238576-.5-.5-.5h-7.5z" stroke="#5F5F5F" fill="#5F5F5F" />
                <path d="M11 11h9v8c0 .5522847-.4477153 1-1 1h-8v-9z" fill="#0088CE" />
            </g>
        </SvgIcon>
    )
}

export const AllowDenyIcon = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 21 21" {...props}>
            <title>Allow Deny Icon</title>
            <g id="icons/component/color/url-allow-deny" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path d="M18.0512157,9.30533622 C17.4025017,9.10681682 16.7137251,9 16,9 C15.8820301,9 15.7647418,9.00291823 15.6482034,9.00868645 L18.8943583,5.76279696 C19.1574658,5.49944418 19.1574658,5.07123526 18.8943583,4.80775982 L17.1936661,3.10633159 C17.0660988,2.97876434 16.8962136,2.90847969 16.7157795,2.90847969 C16.5353455,2.90847969 16.3654602,2.97876434 16.237893,3.10669958 L11.7379581,7.60638908 C11.4752187,7.86974186 11.4752187,8.29795078 11.7383261,8.56142622 L11.9142217,8.73707652 L13.2487715,7.40215882 L14.5982858,8.75167315 L14.0849029,9.26519757 C11.7587731,9.92537 9.9258111,11.7581622 9.26539954,14.0841914 L9.21494774,14.1346432 L7.86543341,12.7854969 L8.7354666,11.9154637 L8.55981631,11.7398134 C8.43224905,11.6126141 8.2627318,11.5422068 8.08266572,11.5422068 C7.90223165,11.5422068 7.7327144,11.6124914 7.60514715,11.7398134 L3.10521232,16.2391349 C2.84210486,16.5024877 2.84210486,16.9306966 3.10521232,17.1938041 L4.80651789,18.8954776 C5.06202038,19.1509801 5.50666585,19.1506121 5.76155503,18.8958456 L9.0086829,15.6482751 C9.00291704,15.76479 9,15.8820543 9,16 C9,16.7137789 9.10683292,17.4026056 9.30538111,18.0513624 L7.11143735,20.2456053 C6.62336995,20.7336727 5.97449421,21.0024225 5.28403646,21.0024225 C4.59370137,21.0024225 3.94470297,20.73355 3.45639025,20.2452373 L1.75569798,18.5440544 C0.748162011,17.5371317 0.748162011,15.8978925 1.75533,14.8899885 L6.25563281,10.390299 C6.74370021,9.90223164 7.39257595,9.63348179 8.0830337,9.63348179 C8.77349145,9.63348179 9.42199921,9.9023543 9.91043459,10.390299 L10.0860849,10.5659493 L10.565198,10.0868362 L10.3895478,9.91118588 C9.38201178,8.90401789 9.38201178,7.26465604 10.3889344,6.25712007 L14.8892373,1.75718524 C15.37755,1.26887252 16.0265484,1 16.7166381,1 C17.4067279,1 18.0556037,1.26887252 18.544039,1.75681726 L20.2450993,3.45849081 C21.2517766,4.46541347 21.2517766,6.10502065 20.2442407,7.1123113 L18.0512157,9.30533622 Z" id="Combined-Shape" fill="#5F5F5F"></path>
                <path d="M16,21 C13.2385763,21 11,18.7614237 11,16 C11,13.2385763 13.2385763,11 16,11 C18.7614237,11 21,13.2385763 21,16 C21,18.7614237 18.7614237,21 16,21 Z M13,15 L13,17 L19,17 L19,15 L13,15 Z" fill="#0088CE" fillRule="nonzero"></path>
            </g>
        </SvgIcon>
    )
}

export const DirectoryConfiguredIcon = ({ color, title = "Directory Configured Icon", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <title>{title}</title>
            <path d="M22 15.3369209c-.6119874-.8690533-1.4693523-1.5528663-2.4713573-1.9507017C18.9009358 13.136995 18.2164664 13 17.5 13c-3.0375661 0-5.5 2.4624339-5.5 5.5 0 .5200119.0721672 1.0231682.2070325 1.5H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h6l2 2h8c1.1 0 2 .9 2 2v7.3369209z" fill="#EEAA48" /><path d="M17.5 14c2.488464 0 4.5 2.011536 4.5 4.5 0 2.488536-2.011536 4.5-4.5 4.5-2.488536 0-4.5-2.011464-4.5-4.5 0-2.488464 2.011464-4.5 4.5-4.5zm-1.0324721 7.125L20.5 16.8998858 19.8796634 16.25l-3.4121355 3.5716524-1.4055821-1.3548896-.6242474.6493642L16.4675279 21.125z" fill="#5BA71B" />
        </SvgIcon>
    )
}

export const DirectoryDisabledIcon = ({ color, title = "Directory Disabled Icon", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <title>{title}</title>
            <g fill="none" fillRule="evenodd">
                <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" fill="#EEAA48" />
                <path d="M17.5 24c3.0375661 0 5.5-2.4624339 5.5-5.5 0-2.3210998-1.4378074-4.3063816-3.4713573-5.1137808C18.9009358 13.136995 18.2164664 13 17.5 13c-3.0375661 0-5.5 2.4624339-5.5 5.5s2.4624339 5.5 5.5 5.5z" fill="#FFF" />
                <path d="M17.5 14c-2.488536 0-4.5 2.011464-4.5 4.5 0 2.488464 2.011464 4.5 4.5 4.5 2.488464 0 4.5-2.011536 4.5-4.5 0-2.488536-2.011536-4.5-4.5-4.5z" fill="#DD1E31" />
                <path fill="#FFF" d="M19.3203682 16l-1.8252847 1.8243907L15.6706318 16 15 16.6706093 16.8252848 18.495 15 20.3202237l.6706318.6697763 1.8244517-1.8243907L19.3203682 20.99l.6706318-.6697763L18.1657152 18.495 19.991 16.6706093z" />
            </g>
        </SvgIcon>
    )
}

export const DirectoryNotConfiguredIcon = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <title>Directory Not Configured Icon</title>
            <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" fill="#B2B2B2" fillRule="evenodd" />
        </SvgIcon>
    )
}

export const ParameterConfiguredIcon = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <title>Parameter Configured Icon</title>
            <path d="M12.5997096 21H5c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h14c1.105 0 2 .895 2 2v9.2571621c-.4385293-.3621641-.9341563-.657653-1.4713573-.8709429-.5975307-.2372431-1.2464976-.3727881-1.9255378-.3852721L17.2 12.685c.03-.225.05-.455.05-.685 0-.23-.02-.46-.05-.68l1.48-1.16c.13-.105.17-.295.08-.445l-1.4-2.425c-.09-.15-.27-.21-.43-.15l-1.74.7c-.365-.28-.76-.515-1.185-.69l-.26-1.855C13.72 5.13 13.575 5 13.4 5h-2.8c-.175 0-.32.13-.345.295l-.26 1.855c-.43.18-.825.415-1.185.69l-1.74-.7c-.16-.06-.34 0-.43.15l-1.4 2.425c-.09.15-.05.34.08.445l1.48 1.155c-.03.225-.05.455-.05.685 0 .235.02.46.05.685L5.32 13.84c-.13.105-.17.295-.08.445l1.4 2.425c.09.15.27.21.43.15l1.74-.7c.365.28.76.515 1.185.69l.26 1.855c.025.165.17.295.345.295h1.4224215c.0644236.7149051.2656452 1.3903641.5772881 2zM12 10c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z" fill="#5F5F5F" fillRule="nonzero" /><path d="M17.5 14c2.488464 0 4.5 2.011536 4.5 4.5 0 2.488536-2.011536 4.5-4.5 4.5-2.488536 0-4.5-2.011464-4.5-4.5 0-2.488464 2.011464-4.5 4.5-4.5zm-1.0324721 7.125L20.5 16.8998858 19.8796634 16.25l-3.4121355 3.5716524-1.4055821-1.3548896-.6242474.6493642L16.4675279 21.125z" fill="#5BA71B" />
        </SvgIcon>
    )
}

export const AddParameterIcon = ({ color, title = "Add Parameter Icon", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <title>{title}</title>
            <path d="M12 20H4c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h14c1.105 0 2 .895 2 2v4h-2.6527835L16.36 6.29c-.09-.15-.27-.21-.43-.15l-1.74.7c-.365-.28-.76-.515-1.185-.69l-.26-1.855C12.72 4.13 12.575 4 12.4 4H9.6c-.175 0-.32.13-.345.295l-.26 1.855c-.43.18-.825.415-1.185.69l-1.74-.7c-.16-.06-.34 0-.43.15l-1.4 2.425c-.09.15-.05.34.08.445l1.48 1.155c-.03.225-.05.455-.05.685 0 .235.02.46.05.685L4.32 12.84c-.13.105-.17.295-.08.445l1.4 2.425c.09.15.27.21.43.15l1.74-.7c.365.28.76.515 1.185.69l.26 1.855c.025.165.17.295.345.295H12v2zM11 9c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm6 9v-3h-3v-2h3v-3h2v3h3v2h-3v3h3l-4 4-4-4h3z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
}

export const AddUrlIcon = ({ color, title = "Add URL Icon", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <title>{title}</title>
            <path d="M18.8208968 8h-2.4295972l1.7136229-1.71348273c.2367967-.2370175.2367967-.62240553 0-.85953343l-1.530623-1.53128541c-.1148106-.11481052-.2677073-.17806671-.4300979-.17806671-.1623907 0-.3152874.06325619-.4300979.1783979l-4.0499414 4.04972055c-.2364655.23701751-.2364655.62240553.0003312.85953343l.1583061.15808527 1.2010947-1.20142593 1.2145629 1.2145629-1.2010947 1.20142596.158306.158306c.0850695.0848245.1933608.138314.3076923.1604014L13 11l-.768548.768548c-.0876722-.0659-.1712931-.1384223-.250236-.2173057l-.1586372-.1586372-.4312019.4312018.1583061.1583061c.9067824.9067823.9067824 2.382208 0 3.2889904l-4.04938939 4.0499413c-.43926066.4392607-1.02324882.6811356-1.6446608.6811356-.62130158 0-1.20540014-.2419853-1.64488159-.6814668l-1.53062304-1.5310646c-.90678237-.9062304-.90678237-2.3815456-.00033118-3.2886592l4.05027253-4.0497206c.43926066-.4392606 1.02324882-.68113549 1.6446608-.68113549s1.20506896.24198529 1.64466077.68113549l.1580853.1580853.4312018-.4312018-.1580852-.1580853c-.9067824-.9064512-.9067824-2.38187687-.000552-3.28865924l4.0502725-4.04994134C14.939795 2.24198526 15.5238935 2 16.1449743 2c.6210808 0 1.205069.24198526 1.6446608.68113553l1.5309543 1.5315062c.9060096.9062304.9060096 2.38187686-.0007728 3.28843844L18.8208968 8zm-8.644414 5.038149l-.78302983.7830299-1.2145629-1.2142317.78302987-.7830299-.15808526-.1580853c-.11481053-.1144793-.26737606-.1778459-.42943553-.1778459-.16239066 0-.31495619.0632562-.42976672.1778459l-4.04994134 4.0493894c-.23679671.2370175-.23679671.6224055 0 .8592023l1.53117501 1.5315062c.22995224.2299522.63013316.229621.85953343.0003311l4.04938937-4.0499413c.2371279-.2370175.2371279-.6227367 0-.8598646l-.1583061-.1583061zM17 18v-3h-3v-2h3v-3h2v3h3v2h-3v3h3l-4 4-4-4h3z" fill="#5F5F5F" fillRule="evenodd" />
        </SvgIcon>
    )
}



export const CheckboxUnselected = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="-1 -1 20 20" {...props}>
            <title>Checkbox Unselected</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect id="Rectangle" stroke="#DDDDDD" fill="#FFFFFF" x="0.5" y="0.5" width="17" height="17" rx="2"></rect>
            </g>
        </SvgIcon>
    )
}

export const CheckboxSelected = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="-1 -1 20 20" {...props}>
            <title>Checkbox Selected</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect id="Rectangle" stroke="#DDDDDD" fill="#FFFFFF" x="0.5" y="0.5" width="17" height="17" rx="2"></rect>
                <polygon id="Path" fill="#0088CE" points="6.75 14 3 10.25 4.2484949 8.9953541 6.75 11.5925293 13.7593269 5 15 6.1997891"></polygon>
            </g>
        </SvgIcon>
    )
}

export const RadioUnselected = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="-1 -1 20 20" {...props}>
            <title>Radio Unselected</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <circle id="radio-button" stroke="#DDDDDD" fill="#FFFFFF" cx="9" cy="9" r="8.5"></circle>
            </g>
        </SvgIcon>
    )
}

export const RadioSelected = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="-1 -1 20 20" {...props}>
            <title>Radio Selected</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <circle id="radio-button" stroke="#DDDDDD" fill="#FFFFFF" cx="9" cy="9" r="8.5"></circle>
                <circle id="selection" fill="#0088CE" cx="9" cy="9" r="5"></circle>
            </g>
        </SvgIcon>
    )
}

export const ServerInService = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 21 21" {...props}>
            <title>Checkbox Unselected</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path d="M18.25,6.75 C17.56,6.75 17,6.19 17,5.5 C17,4.81 17.56,4.25 18.25,4.25 C18.94,4.25 19.5,4.81 19.5,5.5 C19.5,6.19 18.94,6.75 18.25,6.75 Z M6.375,6.75 L7.625,6.75 L7.625,4.25 L6.375,4.25 L6.375,6.75 Z M3.875,6.75 L5.125,6.75 L5.125,4.25 L3.875,4.25 L3.875,6.75 Z M19.5,3 C20.88,3 22,4.12 22,5.5 L22,8 L2,8 L2,5.5 C2,4.12 3.12,3 4.5,3 L19.5,3 Z M16.4965,19.875 L17.7465,18.625 L18.87525,18.625 L18.87525,19.875 L16.4965,19.875 Z M8.033875,18.625 L9.283875,19.875 L5.125125,19.875 L5.125125,18.625 L8.033875,18.625 Z M11.375,14.25025 L4.5,14.25025 C3.12,14.25025 2,13.13025 2,11.75025 L2,9.25025 L20.25,9.25025 L18.835,10.66525 C18.65875,10.569 18.465,10.50025 18.25,10.50025 C17.56,10.50025 17,11.06025 17,11.75025 C17,11.96525 17.06875,12.15775 17.165,12.33525 L15.25,14.25025 L12.625,14.25025 L12.625,16.34525 L11.375,15.09525 L11.375,14.25025 Z M3.875,13.00025 L5.125,13.00025 L5.125,10.50025 L3.875,10.50025 L3.875,13.00025 Z M6.375,13.00025 L7.625,13.00025 L7.625,10.50025 L6.375,10.50025 L6.375,13.00025 Z" id="Combined-Shape" fill="#5F5F5F"></path>
                <polygon id="Fill-10" fill="#5BA71B" points="12.9697038 18.4545557 9.65698166 15.1418335 8 16.797574 12.9697038 21.7672778 22.0799999 12.6569817 20.4230183 11"></polygon>
            </g>
        </SvgIcon>
    )
}

export const ServerOutOfService = ({ color, ...props }) => {
    return (
        <SvgIcon {...props}>
            <title>Server Out Of Service</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <polygon id="Fill-1" fill="#DD1E31" points="4.80832864 2 3 3.80705067 19.5829487 20.3899994 21.3899994 18.5816707"></polygon>
                <path d="M12.775,8 L7.775,3 L19.5,3 C20.88,3 22,4.12 22,5.5 L22,8 L12.775,8 Z M4.45425,6.75 L5.70425,8 L2.0005,8 L2.0005,5.5 C2.0005,5.14625 2.0755,4.81 2.20925,4.505 L3.8755,6.17125 L3.8755,6.75 L4.45425,6.75 Z M17.277125,12.502 L14.024625,9.2495 L21.999625,9.2495 L21.999625,11.7495 C21.999625,13.13075 20.880875,14.2495 19.499625,14.2495 L19.024625,14.2495 L17.498375,12.72325 C17.709625,12.887 17.962125,12.9995 18.249625,12.9995 C18.940875,12.9995 19.499625,12.44075 19.499625,11.7495 C19.499625,11.0595 18.940875,10.4995 18.249625,10.4995 C17.559625,10.4995 16.999625,11.0595 16.999625,11.7495 C16.999625,12.03825 17.113375,12.29075 17.277125,12.502 Z M16.32875,18.625 L17.57875,19.875 L14.41125,19.875 C14.1325,20.95125 13.16375,21.75 12,21.75 C10.83625,21.75 9.8675,20.95125 9.58875,19.875 L5.125,19.875 L5.125,18.625 L9.58875,18.625 C9.815,17.75 10.5,17.065 11.375,16.83875 L11.375,14.25 L4.5,14.25 C3.12,14.25 2,13.13 2,11.75 L2,9.25 L6.95375,9.25 L12.625,14.92125 L12.625,16.83875 C13.5,17.065 14.185,17.75 14.41125,18.625 L16.32875,18.625 Z M6.375,13 L7.625,13 L7.625,10.5 L6.375,10.5 L6.375,13 Z M3.875,13 L5.125,13 L5.125,10.5 L3.875,10.5 L3.875,13 Z M12,20.5 C12.69,20.5 13.25,19.94 13.25,19.25 C13.25,18.56 12.69,18 12,18 C11.31,18 10.75,18.56 10.75,19.25 C10.75,19.94 11.31,20.5 12,20.5 Z M18.25,4.25 C17.56,4.25 17,4.81 17,5.5 C17,6.19 17.56,6.75 18.25,6.75 C18.94,6.75 19.5,6.19 19.5,5.5 C19.5,4.81 18.94,4.25 18.25,4.25 Z" id="Combined-Shape" fill="#5F5F5F"></path>
            </g>
        </SvgIcon>
    )
}

export const NotSorted = ({ color, ...props }) => {
    return (
        <SvgIcon {...props}>
            <title>Not Sorted</title>
            <g strokeWidth="1" fill="none" fillRule="evenodd">
                <polyline stroke="#AFAFAF" strokeWidth="2" transform="translate(12.000000, 16.498299) scale(1, -1) translate(-12.000000, -16.498299) " points="9 17.9965975 12 15 15 17.9957178"></polyline>
                <polyline stroke="#AFAFAF" strokeWidth="2" points="9 8.99659746 12 6 15 8.99571776"></polyline>
            </g>
        </SvgIcon>
    )
}


export const SortAZ = ({ color, ...props }) => {
    return (
        <SvgIcon {...props}>
            <title>SortAZ</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <polyline stroke="#5F5F5F" strokeWidth="2" points="8 13.9965975 12 10 16 13.9957178"></polyline>
            </g>
        </SvgIcon>
    )
}

export const ExpandIcon = ({ color, ...props }) => {
    return (
        <SvgIcon {...props}>
            <title>ExpandIcon</title>
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z">
            </path>
            <path fill="none" d="M0 0h24v24H0z"></path>
        </SvgIcon>
    )
}

export const MoreVertIcon = ({ color, ...props }) => {
    return (
        <SvgIcon {...props}>
            <title>ExpandIcon</title>
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>
        </SvgIcon>
    )
}

export const MoreIcon = ({ color, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 60 60" height='20px' {...props}>
            <title>ExpandIcon</title>
            <path d="M8,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S12.411,22,8,22z" />
            <path d="M52,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S56.411,22,52,22z" />
            <path d="M30,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,22,30,22z" />
        </SvgIcon>
    )
}

export const CollapsePlusBox = ({ disabled, color, backgroundFill = "#fff", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <title>collapse Plus Box</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-34.000000, -403.000000)">
                    <g transform="translate(16.000000, 362.000000)">
                        <g transform="translate(0.000000, 33.000000)">
                            <g transform="translate(14.000000, 4.000000)">
                                <path d="M4,5.99406028 C4,4.8927712 4.89451376,4 5.99406028,4 L18.0059397,4 C19.1072288,4 20,4.89451376 20,5.99406028 L20,18.0059397 C20,19.1072288 19.1054862,20 18.0059397,20 L5.99406028,20 C4.8927712,20 4,19.1054862 4,18.0059397 L4,5.99406028 Z" id="Path" fill={backgroundFill} fillRule="nonzero"></path>
                                <path d="M4,5.99406028 C4,4.8927712 4.89451376,4 5.99406028,4 L18.0059397,4 C19.1072288,4 20,4.89451376 20,5.99406028 L20,18.0059397 C20,19.1072288 19.1054862,20 18.0059397,20 L5.99406028,20 C4.8927712,20 4,19.1054862 4,18.0059397 L4,5.99406028 Z M5,5.99406028 L5,18.0059397 C5,18.5539384 5.44579254,19 5.99406028,19 L18.0059397,19 C18.5539384,19 19,18.5542075 19,18.0059397 L19,5.99406028 C19,5.44606163 18.5542075,5 18.0059397,5 L5.99406028,5 C5.44606163,5 5,5.44579254 5,5.99406028 Z M11,11 L11,8 L13,8 L13,11 L16,11 L16,13 L13,13 L13,16 L11,16 L11,13 L8,13 L8,11 L11,11 Z" id="Rectangle-14" fill={disabled ? '#CFCFCF' : '#5F5F5F'} fillRule="evenodd"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export const MinusBlueCircle = ({ disabled, color, backgroundFill = "#fff", ...props }) => {
    return (
        <SvgIcon viewBox="3 3 16 16" {...props} style={{ width: '15px', height: '15px' }}>
            <title>collapse Plus Box</title>
            <circle cx="11" cy="-1041.36" r="8" transform="matrix(1 0 0-1 0-1030.36)" opacity=".98" fill="#1d99f3" /><path d="m321.29 365.13c0 0-66.11 0-82.2.043v29.962c16.09-.022 82.2-.022 82.2-.022h29.983 82.18v-29.983h-82.18z" fill="#fff" transform="matrix(.05956 0 0 .05956-9.03-11.652)" />
        </SvgIcon>
    )
}

export const CollapseMinusBox = ({ color, backgroundFill = "#fff", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <title>collapse Minus Box</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-34.000000, -436.000000)">
                    <g transform="translate(16.000000, 362.000000)">
                        <g transform="translate(0.000000, 66.000000)">
                            <g transform="translate(14.000000, 4.000000)">
                                <path d="M4,5.99406028 C4,4.8927712 4.89451376,4 5.99406028,4 L18.0059397,4 C19.1072288,4 20,4.89451376 20,5.99406028 L20,18.0059397 C20,19.1072288 19.1054862,20 18.0059397,20 L5.99406028,20 C4.8927712,20 4,19.1054862 4,18.0059397 L4,5.99406028 Z" id="Path" fill={backgroundFill} fillRule="nonzero"></path>
                                <path d="M4,5.99406028 C4,4.8927712 4.89451376,4 5.99406028,4 L18.0059397,4 C19.1072288,4 20,4.89451376 20,5.99406028 L20,18.0059397 C20,19.1072288 19.1054862,20 18.0059397,20 L5.99406028,20 C4.8927712,20 4,19.1054862 4,18.0059397 L4,5.99406028 Z M5,5.99406028 L5,18.0059397 C5,18.5539384 5.44579254,19 5.99406028,19 L18.0059397,19 C18.5539384,19 19,18.5542075 19,18.0059397 L19,5.99406028 C19,5.44606163 18.5542075,5 18.0059397,5 L5.99406028,5 C5.44606163,5 5,5.44579254 5,5.99406028 Z M8,11 L16,11 L16,13 L8,13 L8,11 Z" id="Combined-Shape" fill="#5F5F5F" fillRule="evenodd"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export const PlusIcon = ({ disabled, color, backgroundFill = "#fff", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props} style={{ width: "16", height: "16" }}>
            <title>collapse Plus Box</title>
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /><path d="M0 0h24v24H0z" fill="none" />
        </SvgIcon>
    )
}

export const MinusIcon = ({ disabled, color, backgroundFill = "#fff", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props} style={{ width: "16", height: "16" }}>
            <title>collapse Plus Box</title>
            <path d="M19 13H5v-2h14v2z" /><path d="M0 0h24v24H0z" fill="none" />
        </SvgIcon>
    )
}


export const AzureLogoIcon = ({ disabled, color, backgroundFill = "#fff", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 52.91666 15.244921" {...props} style={{ width: "140", height:"30" }}>
            <title>AzureLogo</title>
            <g
                transform="translate(677.9313,-313.85407)">
                <g transform="matrix(0.03978217,0,0,0.03978217,-658.51488,317.36166)">
                    <path fill="#0089d6" strokeWidth="0.28222221" d="m -259.18627,274.57516 c 63.5635,-11.22863 116.06332,-20.52032 116.66629,-20.64819 l 1.09632,-0.2325 -60.01021,-71.38026 c -33.00559,-39.25915 -60.01018,-71.53249 -60.01018,-71.71853 0,-0.35223 61.96561,-170.992127 62.31396,-171.599207 0.11647,-0.20297 42.28595,72.60148 102.221586,176.482797 56.11284,97.25555 102.3751556,177.4431 102.8051496,178.19452 l 0.78184,1.36624 -190.7173956,-0.0246 -190.71736,-0.0245 115.57,-20.4157 z m 731.37889,-17.26291 c -29.03093,-1.86128 -45.91544,-18.39214 -50.38974,-49.33422 -1.19021,-8.2311 -1.19476,-8.44466 -1.31656,-61.88078 l -0.11789,-51.717227 h 12.84834 12.8483 l 0.10118,50.023887 c 0.0912,45.08514 0.14842,50.37131 0.57946,53.54292 1.74935,12.87168 5.23201,21.5276 11.16124,27.74067 4.74528,4.97242 10.30038,7.8839 17.99011,9.42882 3.62783,0.72884 13.94813,0.7303 17.25569,0.003 7.79588,-1.7156 14.0442,-5.10811 19.55617,-10.61799 6.28249,-6.28012 10.93015,-15.1903 13.17899,-25.26595 l 0.75793,-3.39586 0.0844,-50.44723 0.0844,-50.447217 h 13.11732 13.11735 v 79.304447 79.30444 h -12.98222 -12.98222 v -12.5824 c 0,-8.54933 -0.0937,-12.55118 -0.29222,-12.485 -0.16069,0.0536 -0.82744,1.07357 -1.48166,2.26667 -4.47373,8.15896 -11.92745,15.62029 -20.09501,20.1155 -9.79024,5.38827 -19.60858,7.30422 -33.02333,6.44412 z m 294.66636,-0.12816 c -10.24795,-0.7703 -21.03846,-4.29359 -29.85796,-9.74908 -18.58873,-11.49853 -29.58761,-30.45184 -32.80805,-56.53499 -1.11441,-9.02575 -1.24835,-21.14964 -0.3184,-28.81907 2.07786,-17.13682 8.81185,-33.95976 18.40106,-45.96982 2.45824,-3.07883 8.03495,-8.65553 11.11365,-11.11361 8.31379,-6.637877 18.03843,-11.279617 28.36334,-13.538327 6.01579,-1.31603 16.60968,-1.93394 23.00111,-1.34159 16.05576,1.48805 30.77105,9.04765 40.77267,20.945887 10.1615,12.08847 15.74681,28.98006 16.46007,49.77987 0.11179,3.25966 0.13889,8.97466 0.0603,12.7 l -0.143,6.77333 -56.23278,0.0712 -56.23278,0.0712 v 2.5094 c 0,7.63915 1.85722,16.33991 5.06795,23.74265 2.76877,6.38373 7.53485,13.35462 11.43714,16.72802 8.00131,6.91687 17.79386,11.05701 28.50936,12.05334 3.97318,0.3694 14.09889,-0.0195 18.62666,-0.7152 12.91802,-1.98524 25.19946,-7.052 35.11745,-14.48783 1.16688,-0.87486 2.28357,-1.69223 2.48152,-1.81635 0.28968,-0.18164 0.35814,2.10408 0.35081,11.71222 l -0.009,11.93792 -2.65743,1.64355 c -11.21971,6.93911 -24.07305,11.39481 -37.68211,13.06277 -4.06135,0.49775 -18.96443,0.71949 -23.82142,0.35441 z m 48.93919,-100.68528 c 0,-12.79609 -5.39245,-27.01096 -13.02337,-34.3305 -5.44587,-5.22367 -12.02921,-8.41603 -19.85552,-9.62822 -3.70264,-0.5735 -11.50631,-0.35262 -15.41004,0.43617 -8.25234,1.66748 -15.07811,5.29536 -21.03154,11.17821 -6.26561,6.19133 -10.96323,13.71122 -13.91756,22.27909 -1.06234,3.08091 -2.30488,8.13901 -2.69056,10.95257 l -0.18376,1.34056 h 43.05616 43.05619 z M 53.010852,253.20058 c 0.06587,-0.19403 19.161194,-50.3586 42.434086,-111.47682 l 42.314342,-111.124037 13.59583,-8.5e-4 13.5958,-8.4e-4 1.12805,2.89278 c 3.4472,8.84008 84.71032,219.821587 84.71032,219.931197 0,0.0722 -6.50875,0.13039 -14.46389,0.12923 l -14.46389,-0.003 -11.71222,-31.18282 -11.71222,-31.18281 -47.15885,-5.7e-4 -47.15886,-5.6e-4 -0.40982,1.05833 c -0.22538,0.58208 -5.229376,14.61335 -11.120031,31.18062 l -10.710221,30.12225 -14.494087,0.005 c -11.4727,0.004 -14.469109,-0.0686 -14.374339,-0.34784 z M 189.82928,167.38571 c 0,-0.0494 -7.88187,-21.41719 -17.51527,-47.48389 -18.02243,-48.766297 -19.03061,-51.700447 -20.45454,-59.529577 -0.66771,-3.67122 -1.00556,-3.77324 -1.40188,-0.42333 -0.2833,2.39448 -1.51167,7.75245 -2.45866,10.72445 -0.46988,1.47461 -8.58577,23.74972 -18.03533,49.500237 -9.44954,25.75052 -17.18099,46.92777 -17.18099,47.06055 0,0.13279 17.33551,0.24143 38.52334,0.24143 21.18783,0 38.52333,-0.0404 38.52333,-0.0899 z m 69.70889,82.10639 v -4.06127 l 46.98461,-64.58929 46.98461,-64.5893 -42.53961,-0.14111 -42.53961,-0.14111 -0.0739,-10.795 -0.0739,-10.794997 h 61.52781 61.5278 v 3.64606 3.646057 l -46.99,64.94153 c -25.8445,35.71785 -46.99,65.00162 -46.99,65.07506 0,0.0734 20.8915,0.13352 46.42555,0.13352 h 46.42556 v 10.86555 10.86556 h -65.33447 -65.33445 z m 344.78149,3.8731 c -0.10349,-0.10346 -0.18816,-35.91746 -0.18816,-79.58666 V 94.380023 h 12.84112 12.84111 v 16.368887 c 0,9.00289 0.10947,16.36889 0.2433,16.36889 0.13383,0 0.75881,-1.47368 1.38884,-3.27484 2.88711,-8.2536 7.89393,-15.96572 14.34443,-22.09509 5.81095,-5.521657 12.45235,-8.823637 20.28898,-10.087287 2.20134,-0.35497 4.064,-0.42274 8.46667,-0.30806 5.52924,0.14402 8.42001,0.54819 11.78278,1.64738 l 1.05833,0.34594 v 13.328937 13.32893 l -3.03389,-1.51868 c -5.3592,-2.68267 -10.64714,-3.74429 -17.00389,-3.41375 -4.13707,0.21513 -6.85252,0.74636 -10.16,1.98766 -6.80519,2.55399 -12.32518,7.06198 -16.18228,13.2155 -5.58374,8.90817 -9.56612,20.35873 -10.7407,30.88287 -0.21079,1.88864 -0.33508,17.27019 -0.38459,47.59327 l -0.0731,44.80278 H 617.1582 c -6.95771,0 -12.73506,-0.0847 -12.83852,-0.18816 z M -488.0685,252.80762 c 0,-0.1005 28.27652,-49.18632 62.83671,-109.07964 l 62.8367,-108.896937 73.22891,-61.45385 c 40.2759,-33.79961 73.33737,-61.49516 73.46992,-61.54567 0.13255,-0.0505 -0.39727,1.28299 -1.17738,2.96333 -0.78011,1.68034 -36.56244,78.4296699 -79.51629,170.55406 l -78.09789,167.498887 -56.79034,0.0712 c -31.23468,0.0392 -56.79034,-0.011 -56.79034,-0.11142 z" />
                </g>
            </g >
        </SvgIcon >
    )
}